// extracted by mini-css-extract-plugin
export default {"container":"VerifyOtp_container__CeVoC","form":"VerifyOtp_form__A7i9F","btns":"VerifyOtp_btns__jLqn9"};